import GraphQL from './GraphQL'

class PersonalClass {
    save(cb, params={}) {
        GraphQL.query('personal_profile', {
            'NAME : String!' : params.NAME,
            'LAST_NAME : String!' : params.LAST_NAME,
            'PERSONAL_PHONE : String!' : params.PERSONAL_PHONE,
            'EMAIL : String!' : params.EMAIL,
            'SECOND_NAME : String' : params.SECOND_NAME,
            'PERSONAL_BIRTHDAY : String' : params.PERSONAL_BIRTHDAY,
            'PERSONAL_GENDER : String' : params.PERSONAL_GENDER
        }, {}, cb)
    }

    changePassword(cb, params={}) {
        GraphQL.query('personal_change_password', {
            'PASSWORD : String!' : params.PASSWORD,
            'NEW_PASSWORD : String!' : params.NEW_PASSWORD,
            'CONFIRM_PASSWORD : String!' : params.CONFIRM_PASSWORD
        }, {}, cb)
    }

    changeCardNumber(cb, params={}) {
        GraphQL.query('personal_change_card_number', {
            'CARD_NUMBER : String!' : params.CARD_NUMBER
        }, {}, cb)
    }
}

const Personal = new PersonalClass()

export default Personal